import React from "react"

import bem from "../../../../../bem"

import { SuggestionList } from "./SuggestionList"

import "./Suggestions.scss"

interface Props {
    inModal?: boolean
    suggestions: Search.Suggestion[]
    onSuggestionClick: (suggestion: Search.Suggestion) => void
    focusedSuggestionCode: string | null
}

const b = bem.with("NewUI__smartSearchField")

export default function Suggestions(props: Props): JSX.Element {
    const { suggestions, onSuggestionClick, focusedSuggestionCode } = props
    const inModal = props.inModal ?? false
    return (
        <div className="tw-relative tw-w-full tw-z-1">
            <div
                className={`bg-darkest ${b("suggestions", {
                    inModal: inModal.toString(),
                })}`}
                id="smartSearchSuggestionsList"
                data-ft-suggestions-list
            >
                <SuggestionList
                    suggestions={suggestions}
                    onSuggestionClick={onSuggestionClick}
                    focusedSuggestionCode={focusedSuggestionCode}
                />
            </div>
        </div>
    )
}
